import React from "react";
import DatePicker from "../../../../components/DatePicker";

/**
 * Attendance-specific DatePicker wrapper.
 * Delegates to the shared DatePicker component.
 */
const AttendanceDatePicker = ({ theme, isRTL, t, selectedDate, setSelectedDate }) => {
  return (
    <DatePicker
      theme={theme}
      isRTL={isRTL}
      label={t.selectDate}
      value={selectedDate}
      onChange={setSelectedDate}
      dropDirection="down"
    />
  );
};

export default AttendanceDatePicker;